module.exports = "<input type=\"checkbox\" id=\"{{id}}\" [(ngModel)]=\"internalModel\" (ngModelChange)=\"inputFieldChanged($event)\" [disabled]=\"disableCheckbox\"/>\n<label [attr.for]=\"id\" class=\"{{cssClass}}\">\n\t<span class=\"checkbox\"></span>\n\t<ng-content></ng-content>\n</label>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/checkbox/checkbox.html
// module id = n+bb
// module chunks = 12